<div *ngIf="isLoading">
    <mat-spinner
      [diameter]="20">
    </mat-spinner>
</div>
<div *ngIf="!isLoading">{{displayText}}</div>
